export const searchRows = (text, initialRows) => {
  const searchText = text.toLowerCase();
  return initialRows.filter((row) =>
    Object.values(row).some((value) =>
      typeof value === 'object'
        ? Object.values(value).some((subValue) =>
            String(subValue).toLowerCase().includes(searchText)
          )
        : String(value).toLowerCase().includes(searchText)
    )
  );
};

export const searchRows2 = (text, initialRows) => {
  const searchText = text.toLowerCase();

  const includesSearchText = (value) =>
    String(value).toLowerCase().includes(searchText);
  
  return initialRows.filter((row) =>
    Object.values(row).some((value) => {
      if (typeof value === 'object' && value !== null) {
        return Object.values(value).some((subValue) =>
          includesSearchText(subValue)
        );
      }
      return includesSearchText(value);
    })
  );
};
